
















































































import { Action, Getter } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import DpInput from '@/components/atoms/DpInput/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import DpDialog from '@/components/molecules/DpDialog/index.vue';
import MarketRegionSubscribedSuccessDialog from '@/components/organisms/MarketRegion/SubscribedSuccessDialog/index.vue';
import SubscriberActionTypes from '@/modules/subscriber/SubscriberActionTypes';
import DpAddToFavorite from '@/components/molecules/DpAddToFavorite/index.vue';

@Component({
  name: 'MarketRegionSubscribe',
  components: {
    SvgIcon,
    DpInput,
    DpButton,
    DpDialog,
    MarketRegionSubscribedSuccessDialog,
    DpAddToFavorite,
  },
})
export default class MarketRegionSubscribe extends Vue {
  protected email: string = '';

  @Prop() protected isFavorite!: boolean;

  @Prop() protected marketUri!: string;

  @Prop() protected marketTitle!: string;

  @Getter('isAuthenticated', { namespace: 'auth' })
  protected isAuthenticated!: boolean;

  @Action(SubscriberActionTypes.MARKET_SUBSCRIBE, { namespace: 'subscriber' })
  protected dispatchMarketSubscribe!: any;

  protected showSubscribedSuccessDialog: any = false;

  protected showMobileSubscribeDialog: any = false;

  protected onShowMobileSubscribeDialog() {
    this.showMobileSubscribeDialog = true;
  }

  protected onCloseMobileSubscribeDialog() {
    this.showMobileSubscribeDialog = false;
  }

  protected onSubscribe() {
    if (!this.email || !this.email.length) {
      return;
    }
    this.dispatchMarketSubscribe({
      email: this.email,
      marketUri: this.marketUri,
      title: `receiving the updates for the ${this.marketTitle} market`,
    });
    this.showMobileSubscribeDialog = false;
    this.showSubscribedSuccessDialog = true;
  }

  protected onChangeFavorite(value: any) {
    this.$emit('onChangeFavorite', value);
  }
}
